import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import React, { useCallback } from "react";
import TextFieldFormControl from "../../field/TextFieldFormControl/TextFieldFormControl";
import AutocompleteField from "../../field/AutocompleteField";
import IconButtonWithTooltip from "../../button/IconButtonWithTooltip";
import AddButton from "@mui/icons-material/Add";

const SurveyQuestionDetailsForm = React.memo(({ formValue, setFormValue, onChange, onChangeAutocompleteWithCallback, filteringData, isNew, onOpenNewCategoryDialog, questionKinds }) => {
  const { t } = useTranslation();

  const handleChangeKind = useCallback((name, value) => {
    let selectedKind = filteringData?.question_kinds.find(rk => rk.id === value)

    if (isNew) {
      setFormValue((prev) => ({ ...prev, ...selectedKind }))
    }

  }, [filteringData])


  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      spacing={1}
    >
      <Grid item xs={isNew ? 12 : 11}>
        <AutocompleteField
          name="hrquestionkind"
          multiple={false}
          isObjectOption={true}
          optionLabelKey={"hrquestionkind_name"}
          value={formValue.hrquestionkind}
          options={questionKinds}
          label={t("form.survey_question_details_form.category")}
          onChange={onChangeAutocompleteWithCallback(
            handleChangeKind
          )}
          required
        />
      </Grid>
      { !isNew &&
      <Grid item xs={1}

      >
        <IconButtonWithTooltip
          style={{ border: "3px solid var(--secondary)" }}
          title={t(`form.survey_question_details_form.add_category`)}
          onClick={onOpenNewCategoryDialog}
        >
          <AddButton
            fontSize="medium"
            sx={{
              color: "var(--secondary)",
            }}
          />
        </IconButtonWithTooltip>
      </Grid>}
      <Grid item xs={12}>
        <TextFieldFormControl
          name="hrquestion_name"
          label={t("form.survey_question_details_form.question")}
          value={formValue?.hrquestion_name}
          onChange={onChange}
          multiline
          rows={3}
          required
        />
      </Grid>
    </Grid>
  );
});

SurveyQuestionDetailsForm.propTypes = {
  formValue: PropTypes.object,
  onChange: PropTypes.func,
};

export default SurveyQuestionDetailsForm;
